export type SortOrder = 'ascending' | 'descending';

export const sortByAtoZtoNumber = (
  a: string,
  b: string,
  sortOrder: SortOrder = 'ascending',
): number => {
  const aNumber = parseFloat(a);
  const bNumber = parseFloat(b);

  if (!Number.isNaN(aNumber) && !Number.isNaN(bNumber)) {
    return sortOrder === 'ascending' ? aNumber - bNumber : bNumber - aNumber;
  }

  if (!Number.isNaN(aNumber)) return sortOrder === 'ascending' ? 1 : -1;
  if (!Number.isNaN(bNumber)) return sortOrder === 'ascending' ? -1 : 1;

  if (typeof a === 'string' && typeof b === 'string') {
    const aLower = a.toLowerCase();
    const bLower = b.toLowerCase();

    return sortOrder === 'ascending'
      ? aLower.localeCompare(bLower)
      : bLower.localeCompare(aLower);
  }

  return 0;
};
